import { Component, Input } from '@angular/core'
import { MediaQueryService } from '../../services/media-query-service'

@Component({
  selector: 'header-left-nav-layout',
  styles: [`
    :host { display: block; }
  `],
  template: `
    <nav-bar [isMobile]="isMobile" [sidenav]="snav" [showSidebar]="showSidebar" (bannerShown)="onBannerShown($event)"></nav-bar>
    <mat-sidenav-container>
      <mat-sidenav
        id="mat-sidenav"
        #snav
        [opened]="showSidebar && !isMobile"
        [disableClose]="!isMobile"
        [mode]="mode()"
        [fixedInViewport]="isMobile">
        <div class="container side">
          <ng-content select="[sidenav]"></ng-content>
        </div>
      </mat-sidenav>
      <mat-sidenav-content [class.with-banner]="withBanner">
        <div class="main" [class.no-max-width]="disableMaxWidth" id="main-content-container">
          <ng-content select="[main]"></ng-content>
        </div>
      </mat-sidenav-content>
    <mat-sidenav-container>
  `
})
export class HeaderLeftNavLayout {
  @Input() disableMaxWidth: boolean = false
  @Input() showSidebar: boolean = true
  withBanner: boolean = false

  constructor(private mediaQuery: MediaQueryService) {}

  ngOnChanges(): void {
    this.showSidebar = this.showSidebar === false ? false : true
  }

  get isMobile(): boolean {
    return this.mediaQuery.isUnder('lg')
  }

  mode(): string {
    return this.isMobile ? 'over' : 'side'
  }

  onBannerShown(shown: boolean): void {
    this.withBanner = shown
  }

}
